import React, {useState} from 'react';
import {StyleSheet} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';

import {AppRoute} from '../../models/AppRoute';
import useAppNavigation from '../../navigation/useAppNavigation';

import BaseTile from './BaseTile';

const discoverStyle = StyleSheet.create({
  container: {
    marginHorizontal: 0,
  },
  touchable: {
    marginBottom: 8,
  },
  textHolder: {
    backgroundColor: 'white',
    paddingHorizontal: 0,
    paddingVertical: 0,
  },
  headline: {
    paddingHorizontal: 12,
    marginTop: 8,
    marginBottom: 8,
  },
});

const DiscoverTile = ({item, isActive = false}) => {
  const navigation = useAppNavigation();

  // Used only in tiles on the Feed screen. Discover has too many
  // instances of videos playing that wrapping them in InViewPort
  // craps the UI thread on iOS. Easiest to just let them keep on
  // playing and not bother pausing them when they're out of view.
  const [paused, setPaused] = useState(true);
  useFocusEffect(
    React.useCallback(() => {
      // Do something when the screen is focused
      // component.current.startAutoplay(false);
      setPaused(false);

      return () => {
        // Do something when the screen is unfocused
        // Useful for cleanup functions
        // component.current.stopAutoplay();
        setPaused(true);
      };
    }, []),
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onDiscoverPress = (article: any) => navigation.navigate(AppRoute.ARTICLE, {article});

  return (
    <BaseTile
      item={item}
      customStyles={discoverStyle}
      pressCallback={onDiscoverPress}
      paused={paused}
      includeByline={false}
      headlineVariant="heading4"
      disableAnimations // Required for FlashList - prevents animations on cell recycle
      isVirtualized // Skip InViewPort - FlashList handles visibility, prevents iOS Fabric crash
      isActive={isActive} // Single-active video player: only the most-visible cell plays
    />
  );
};

export default DiscoverTile;
